let agentMsgMap = {
  1: {
    name: 'CONS_EU_AG_AgentLogin_1',
    description: '座席登录',
    flow: 'CCS <- Agent',
  },
  2: {
    name: 'CONS_EU_AG_AgentLoginAck_2',
    description: '座席登录ack',
    flow: 'CCS -> Agent',
  },
  3: {
    name: 'CONS_EU_AG_AgentLoggedOff_3',
    description: '座席下线',
    flow: 'CCS <- Agent',
  },
  4: {
    name: 'CONS_EU_AG_AgentLoggedOffAck_4',
    description: '座席下线ack',
    flow: 'CCS -> Agent',
  },
  5: {
    name: 'CONS_EU_AG_AgentSignInGroup_5',
    description: '签入组',
    flow: 'CCS <- Agent',
  },
  6: {
    name: 'CONS_EU_AG_AgentSignInGroupAck_6',
    description: '签入组ack',
    flow: 'CCS -> Agent',
  },
  7: {
    name: 'CONS_EU_AG_AgentSignOutGroup_7',
    description: '签出组',
    flow: 'CCS <- Agent',
  },
  8: {
    name: 'CONS_EU_AG_AgentSignOutGroupAck_8',
    description: '签出组ack',
    flow: 'CCS -> Agent',
  },
  9: {
    name: 'CONS_EU_AG_AgentSignInSkill_9',
    description: '签入技能',
    flow: 'CCS <- Agent',
  },
  10: {
    name: 'CONS_EU_AG_AgentSignInSkillAck_10',
    description: '签入技能ack',
    flow: 'CCS -> Agent',
  },
  11: {
    name: 'CONS_EU_AG_AgentSignOutSkill_11',
    description: '签出技能',
    flow: 'CCS <- Agent',
  },
  12: {
    name: 'CONS_EU_AG_AgentSignOutSkillAck_12',
    description: '签出技能ack',
    flow: 'CCS -> Agent',
  },
  13: {
    name: 'CONS_EU_AG_AgentGetGroupReq_13',
    description: '座席请求某一个组的信息(组里有的成员列表)',
    flow: 'Agent -> CCS',
  },
  14: {
    name: 'CONS_EU_AG_AgentGetGroupAck_14',
    description: '返回席组的信息',
    flow: 'CCS -> Agent',
  },
  15: {
    name: 'CONS_EU_AG_AgentGetSkillReq_15',
    description: '座席获取技能列表',
    flow: 'Agent -> CCS',
  },
  16: {
    name: 'CONS_EU_AG_AgentGetSkillAck_16',
    description: '座席技能信息',
    flow: 'CCS --> Agent',
  },
  17: {
    name: 'CONS_EU_AG_AgentAnswerCall_17',
    description: '座席摘机',
    flow: 'Agent-->CCS',
  },
  18: {
    name: 'CONS_EU_AG_AgentAnswerCallAck_18',
    description: '座席摘机',
    flow: 'CCS-->Agent',
  },
  19: {
    name: 'CONS_EU_AG_AgentReleaseCall_19',
    description: '座席挂机',
    flow: 'Agent-->CCS',
  },
  20: {
    name: 'CONS_EU_AG_AgentReleaseCallAck_20',
    description: '座席挂机ack',
    flow: 'CCS-->Agent',
  },
  21: {
    name: 'CONS_EU_AG_AgentHoldCall_21',
    description: '座席保持',
    flow: 'Agent-->CCS',
  },
  22: {
    name: 'CONS_EU_AG_AgentHoldCallAck_22',
    description: '座席保持ack',
    flow: 'CCS-->Agent',
  },
  23: {
    name: 'CONS_EU_AG_AgentRetrieveHold_23',
    description: '呼叫找回',
    flow: 'Agent-->CCS',
  },
  24: {
    name: 'CONS_EU_AG_AgentRetrieveHoldAck_24',
    description: '呼叫找回Ack',
    flow: 'CCS-->Agent',
  },
  25: {
    name: 'CONS_EU_AG_AgentConnectHold_25',
    description: '连接一个被保持呼叫与当前正在与座席通话的对方进行联接',
    flow: 'Agent-->CCS',
  },
  26: {
    name: 'CONS_EU_AG_AgentConnectHoldAck_26',
    flow: 'CCS-->Agent',
  },
  27: {
    name: 'CONS_EU_AG_AgentCallAgent_27',
    description: '座席呼座席',
    flow: 'Agent-->CCS',
  },
  28: {
    name: 'CONS_EU_AG_AgentCallAgentAck_28',
    description: '座席呼座席ACK',
    flow: 'CCS-->Agent',
  },
  29: {
    name: 'CONS_EU_AG_AgentCallOut_29',
    description: '外呼',
    flow: 'Agent-->CCS',
  },
  30: {
    name: 'CONS_EU_AG_AgentCallOutAck_30',
    description: '外呼ACK',
    flow: 'CCS-->Agent',
  },
  31: {
    name: 'CONS_EU_AG_AgentConfCall_31',
    description: '会议呼叫',
    flow: 'Agent-->CCS',
  },
  32: {
    name: 'CONS_EU_AG_AgentConfCallAck_32',
    description: '会议呼叫Ack',
    flow: 'CCS-->Agent',
  },
  33: {
    name: 'CONS_EU_AG_AgentInviteToConf_33',
    description: '邀请到会议',
    flow: 'Agent-->CCS',
  },
  34: {
    name: 'CONS_EU_AG_AgentInviteToConfAck_34',
    description: '对邀请到会议的响应',
    flow: 'CCS-->Agent',
  },
  35: {
    name: 'CONS_EU_AG_AgentTransferIVR_35',
    description: '把呼叫转移到IVR',
    flow: 'Agent-->CCS ',
  },
  36: {
    name: 'CONS_EU_AG_AgentTransferIVRAck_36',
    description: '把呼叫转移到IVRack',
    flow: 'CCS-->Agent',
  },
  37: {
    name: 'CONS_EU_AG_AgentTransferOut_37',
    description: '呼转外线',
    flow: 'Agent-->CCS',
  },
  38: {
    name: 'CONS_EU_AG_AgentTransferOutAck_38',
    description: '呼转外线ack',
    flow: 'CCS-->Agent',
  },
  39: {
    name: 'CONS_EU_AG_AgentTransferAgentGroup_39',
    description: '转座席组排队',
    flow: 'Agent-->CCS ',
  },
  40: {
    name: 'CONS_EU_AG_AgentTransferAgentGroupAck_40',
    description: '转座席组排队ack',
    flow: 'CCS-->Agent',
  },
  41: {
    name: 'CONS_EU_AG_AgentTransferAgent_41',
    description: '将当前通话转移到座席',
    flow: 'Agent-->CCS',
  },
  42: {
    name: 'CONS_EU_AG_AgentTransferAgentAck_42',
    description: '将当前通话转移到座席ack',
    flow: 'CCS-->Agent',
  },
  43: {
    name: 'CONS_EU_AG_AgentSnatchCall_43',
    description: '抢接来话',
    flow: 'Agent-->CCS',
  },
  44: {
    name: 'CONS_EU_AG_AgentSnatchCallAck_44',
    description: '抢接来话ack',
    flow: 'CCS-->Agent',
  },
  45: {
    name: 'CONS_EU_AG_AgentKickOut_45',
    description: '踢出会议',
    flow: 'Agent-->CCS',
  },
  46: {
    name: 'CONS_EU_AG_AgentKickOutAck_46',
    description: '踢出会议ACK',
    flow: 'CCS-->Agent',
  },
  47: {
    name: 'CONS_EU_AG_AgentBeginMute_47',
    description: '开始静音',
    flow: 'Agent-->CCS',
  },
  48: {
    name: 'CONS_EU_AG_AgentBeginMuteAck_48',
    description: '开始静音ack',
    flow: 'CCS-->Agent',
  },
  49: {
    name: 'CONS_EU_AG_AgentEndMute_49',
    description: '停止静音',
    flow: 'Agent-->CCS',
  },
  50: {
    name: 'CONS_EU_AG_AgentEndMuteAck_50',
    description: '停止静音ack',
    flow: 'CCS-->Agent',
  },
  51: {
    name: 'CONS_EU_AG_AgentSetBusy_51',
    description: '示忙',
    flow: 'Agent-->CCS',
  },
  52: {
    name: 'CONS_EU_AG_AgentSetBusyAck_52',
    description: '示忙ack',
    flow: 'CCS-->Agent',
  },
  53: {
    name: 'CONS_EU_AG_AgentSetIdle_53',
    description: '示闲',
    flow: 'Agent-->CCS',
  },
  54: {
    name: 'CONS_EU_AG_AgentSetIdleAck_54',
    description: '示闲ack',
    flow: 'CCS-->Agent',
  },
  55: {
    name: 'CONS_EU_AG_AgentRequestRest_55',
    description: '请求休息',
    flow: 'Agent-->CCS',
  },
  56: {
    name: 'CONS_EU_AG_AgentRequestRestAck_56',
    description: '请求休息ack',
    flow: 'CCS-->Agent',
  },
  57: {
    name: 'CONS_EU_AG_AgentRequestTextProc_57',
    description: '请求文书处理',
    flow: 'CCS <- Agent',
  },
  58: {
    name: 'CONS_EU_AG_AgentRequestTextProcAck_58',
    description: '请求文书处理ack',
    flow: 'CCS -> Agent',
  },
  59: {
    name: 'CONS_EU_AG_AgentSetCallData_59',
    description: '设置呼叫数据',
    flow: 'Agent-->CCS',
  },
  60: {
    name: 'CONS_EU_AG_AgentSetCallDataAck_60',
    description: '设置呼叫数据ack',
    flow: 'CCS-->Agent',
  },
  61: {
    name: 'CONS_EU_AG_AgentQueryCallData_61',
    description: '查询呼叫数据',
    flow: 'Agent-->CCS',
  },
  62: {
    name: 'CONS_EU_AG_AgentQueryCallDataAck_62',
    description: '查询呼叫数据ack',
    flow: 'CCS-->Agent',
  },
  63: {
    name: 'CONS_EU_AG_AgentPlayFile_63',
    description: '播放语音',
    flow: 'Agent-->CCS',
  },
  64: {
    name: 'CONS_EU_AG_AgentPlayFileAck_64',
    description: '播放语音ack',
    flow: 'CCS-->Agent',
  },
  65: {
    name: 'CONS_EU_AG_AgentReceiveDTMF_65',
    description: '座席收号',
    flow: 'Agent-->CCS',
  },
  66: {
    name: 'CONS_EU_AG_AgentReceiveDTMFAck_66',
    description: '座席收号ACK',
    flow: 'CCS-->Agent',
  },
  67: {
    name: 'CONS_EU_AG_AgentForceInsert_67',
    description: '强插',
    flow: 'Agent-->CCS',
  },
  68: {
    name: 'CONS_EU_AG_AgentForceInsertAck_68',
    description: '强插Ack',
    flow: 'CCS-->Agent',
  },
  69: {
    name: 'CONS_EU_AG_AgentMonitor_69',
    description: '监听',
    flow: 'Agent-->CCS',
  },
  70: {
    name: 'CONS_EU_AG_AgentMonitorAck_70',
    description: '监听ACK',
    flow: 'CCS-->Agent',
  },
  71: {
    name: 'CONS_EU_AG_AgentForceRelease_71',
    description: '强拆',
    flow: 'Agent-->CCS',
  },
  72: {
    name: 'CONS_EU_AG_AgentForceReleaseAck_72',
    description: '强拆ack',
    flow: 'CCS-->Agent',
  },
  73: {
    name: 'CONS_EU_AG_AgentIntercept_73',
    description: '拦截',
    flow: 'Agent-->CCS',
  },
  74: {
    name: 'CONS_EU_AG_AgentInterceptAck_74',
    description: '拦截ack',
    flow: 'CCS-->Agent',
  },
  75: {
    name: 'CONS_EU_AG_AgentForceLogOut_75',
    description: '强制注销',
    flow: 'Agent-->CCS ',
  },
  76: {
    name: 'CONS_EU_AG_AgentForceLogOutAck_76',
    description: '强制注销ack',
    flow: 'CCS-->Agent',
  },
  77: {
    name: 'CONS_EU_AG_AgentForceIdle_77',
    description: '强制示闲',
    flow: 'Agent-->CCS',
  },
  78: {
    name: 'CONS_EU_AG_AgentForceIdleAck_78',
    description: '强制示闲ack',
    flow: 'CCS-->Agent',
  },
  79: {
    name: 'CONS_EU_AG_AgentForceBusy_79',
    description: '强制示忙',
    flow: 'Agent-->CCS',
  },
  80: {
    name: 'CONS_EU_AG_AgentForceBusyAck_80',
    description: '强制示忙ack',
    flow: 'CCS-->Agent',
  },
  81: {
    name: 'CONS_EU_AG_AgentForceBlock_81',
    description: '强制阻塞',
    flow: 'Agent-->CCS',
  },
  82: {
    name: 'CONS_EU_AG_AgentForceBlockAck_82',
    description: '强制阻塞ack',
    flow: 'CCS-->Agent',
  },
  83: {
    name: 'CONS_EU_AG_AgentApproveRest_83',
    description: '座席同意小休',
    flow: 'Agent-->CCS',
  },
  84: {
    name: 'CONS_EU_AG_AgentApproveRestAck_84',
    description: '座席同意小休ack',
    flow: 'CCS-->Agent',
  },
  85: {
    name: 'CONS_EU_AG_AgentOnForceInsertEvt_85',
    description: '被强插',
    flow: 'CCS-->Agent',
  },
  86: {
    name: 'CONS_EU_AG_AgentOnForceIdleEvt_86',
    description: '被示闲',
    flow: 'CCS-->Agent',
  },
  87: {
    name: 'CONS_EU_AG_AgentOnForceBusyEvt_87',
    description: '被示忙',
    flow: 'CCS-->Agent',
  },
  88: {
    name: 'CONS_EU_AG_AgentOnForceLogOutEvt_88',
    description: '被注销',
    flow: 'CCS-->Agent',
  },
  89: {
    name: 'CONS_EU_AG_AgentOnForceReleaseEvt_89',
    description: '被强制释放',
    flow: 'CCS-->Agent',
  },
  90: {
    name: 'CONS_EU_AG_AgentOnForceBlockEvt_90',
    description: '被强阻塞',
    flow: 'CCS-->Agent',
  },
  91: {
    name: 'CONS_EU_AG_AgentOnAgentAllBusyEvt_91',
    description: '座席全忙',
    flow: 'CCS-->Agent',
  },
  92: {
    name: 'CONS_EU_AG_AgentOnRequestRestEvt_92',
    description: '班长收请求休息',
    flow: 'CCS-->Agent',
  },
  93: {
    name: 'CONS_EU_AG_AgentOnStartRestEvt_93',
    description: '班长同意后座席开始小休',
    flow: 'CCS-->Agent',
  },
  94: {
    name: 'CONS_EU_AG_AgentOnNotAgreeRestEvt_94',
    description: '座席小休请求未被同意',
    flow: 'CCS-->Agent',
  },
  95: {
    name: 'CONS_EU_AG_AgentOnRestTimeOverEvt_95',
    description: '座席结束小休时间已到',
    flow: 'CCS-->Agent',
  },
  96: {
    name: 'CONS_EU_AG_AgentOnStopTextProcessEvt_96',
    description: '停止座席文本处理态事件',
    flow: 'CCS-->Agent',
  },
  97: {
    name: 'CONS_EU_AG_AgentOnCallEndEvt_97',
    description: '呼叫结束事件',
    flow: 'CCS-->Agent',
  },
  98: {
    name: 'CONS_EU_AG_AgentOnCallOfferedEvt_98',
    description: '呼叫来电事件',
    flow: 'CCS-->Agent',
  },
  99: {
    name: 'CONS_EU_AG_AgentOnInviteToConfEvt_99',
    description: '邀请会议完成事件',
    flow: 'CCS-->Agent',
  },
  100: {
    name: 'CONS_EU_AG_AgentOnKickedOutEvt_100',
    description: '被踢出会议',
    flow: 'CCS-->Agent',
  },
  101: {
    name: 'CONS_EU_AG_AgentOnAnsweredEvt_101',
    description: '摘机事件',
    flow: 'CCS-->Agent',
  },
  102: {
    name: 'CONS_EU_AG_AgentOnReturnFromIVREvt_102',
    description: '从呼叫转出返回',
    flow: 'CCS-->Agent',
  },
  103: {
    name: 'CONS_EU_AG_AgentOnReceiveDTMFCompleted_103',
    description: '收号完成',
    flow: 'CCS-->Agent',
  },
  104: {
    name: 'CONS_EU_AG_AgentOnPlayFileCompleted_104',
    description: '放音完成',
    flow: 'CCS-->Agent',
  },
  105: {
    name: 'CONS_EU_AG_AutoAnswerCallSuccessEvt_105',
    description: '自动摘机成功（没有用，暂保留）',
    flow: 'CCS-->Agent',
  },
  106: {
    name: 'CONS_EU_AG_AgentOnLineEvt_106',
    description: '座席上线通知',
    flow: 'CCS-->Agent',
  },
  107: {
    name: 'CONS_EU_AG_AgentOffLineEvt_107',
    description: '座席下线通知',
    flow: 'CCS-->Agent',
  },
  108: {
    name: 'CONS_EU_AG_AgentOnHeldEvt_108',
    description: '座席被保持',
    flow: 'CCS-->Agent',
  },
  109: {
    name: 'CONS_EU_AG_AgentOnRetrievedEvt_109',
    description: '座席被找回',
    flow: 'CCS-->Agent',
  },
  110: {
    name: 'CONS_EU_AG_AgentOnConnectHoldEvt_110',
    description: '座席被连接',
    flow: 'CCS-->Agent',
  },
  111: {
    name: 'CONS_EU_AG_AgentOnInterceptedEvt_111',
    description: '座席被拦截',
    flow: 'CCS-->Agent',
  },
  112: {
    name: 'CONS_EU_AG_AgentOnConnectedEvt_112',
    description: '座席被连接，说明座席电话已经被呼通',
    flow: 'CCS-->Agent',
  },
  113: {
    name: 'CONS_EU_AG_AgentCallComeBackEvt_113',
    description: '被转出去的呼叫又转回来了',
    flow: 'CCS-->Agent',
  },
  114: {
    name: 'CONS_EU_AG_AgentActionTimeOutEvt_114',
    description: '座席操作超时',
    flow: 'CCS-->Agent',
  },
  115: {
    name: 'CONS_EU_AG_RequestAgentStatus_115',
    description: '请求单座席状态',
    flow: 'Agent-->CCS',
  },
  116: {
    name: 'CONS_EU_AG_RequestAgentStatusAck_116',
    description: '请求单座席状态ack',
    flow: 'CCS-->Agent',
  },
  117: {
    name: 'CONS_EU_AG_RequestAgentGroupStatus_117',
    description: '请求座席组状态',
    flow: 'Agent-->CCS',
  },
  118: {
    name: 'CONS_EU_AG_RequestAgentGroupStatusAck_118',
    description: '请求座席组状态ack',
    flow: 'CCS-->Agent',
  },
  119: {
    name: 'CONS_EU_AG_AgentStatusUpdateEvt_119',
    description: '座席状态更新事件主要用于发到系统监控',
    flow: 'Agent-->CCS',
  },
  120: {
    name: 'CONS_EU_AG_AgentMonitorLogin_120',
    description: '座席监控登录',
    flow: 'Monitor --> CCS',
  },
  121: {
    name: 'CONS_EU_AG_AgentMonitorLoginAck_121',
    description: '座席监控登录ack',
    flow: 'CCS --> Monitor',
  },
  122: {
    name: 'CONS_EU_AG_AgentSelfStatusUpdateEvt_122',
    description: '座席自己状态更新事件主要用于发到座席自己',
    flow: 'Agent-->CCS',
  },
  123: {
    name: 'CONS_EU_AG_AgentStopPlayFile_123',
    description: '停止播放语音',
    flow: 'Agent-->CCS',
  },
  124: {
    name: 'CONS_EU_AG_AgentStopPlayFileAck_124',
    description: '停止播放语音ack',
    flow: 'CCS-->Agent',
  },
  125: {
    name: 'CONS_EU_AG_AgentNotifyEvt_125',
    description: '通知座席事件',
    flow: 'Agent-->CCS',
  },
  126: {
    name: 'CONS_EU_AG_AgentEndReceiveDTMF_126',
    description: '座席停止收号',
    flow: 'Agent-->CCS',
  },
  127: {
    name: 'CONS_EU_AG_AgentEndReceiveDTMFAck_127',
    description: '座席停止收号ack',
    flow: 'CCS-->Agent',
  },
  128: {
    name: 'CONS_EU_AG_AgentRoleChangeEvt_128',
    description: '座席角色改变',
    flow: 'Agent-->CCS',
  },
  129: {
    name: 'CONS_EU_AG_MonitorAgentDesktop_129',
    description: '监控座席桌面',
    flow: 'Agent-->CCS',
  },
  130: {
    name: 'CONS_EU_AG_MonitorAgentDesktopAck_130',
    description: '监控座席桌面ack',
    flow: 'CCS-->Agent',
  },
  131: {
    name: 'CONS_EU_AG_AgentLineStatueEvt_131',
    description: '线路状态变化，只针对内线通道',
    flow: 'Agent-->CCS',
  },
  132: {
    name: 'CONS_EU_AG_AgentRequestCallOutEvt_132',
    description: '座席请求外呼',
    flow: 'Agent-->CCS',
  },
  133: {
    name: 'CONS_EU_AG_AgentSendMsg_133',
    description: '座席发消息',
    flow: 'Agent-->CCS',
  },
  134: {
    name: 'CONS_EU_AG_AgentSendMsgAck_134',
    description: '座席发消息ack',
    flow: 'CCS-->Agent',
  },
  135: {
    name: 'CONS_EU_AG_AgentMsgEvt_135',
    description: '座席消息事件',
    flow: 'Agent-->CCS',
  },
  136: {
    name: 'CONS_EU_AG_AgentSetTransferIVR_136',
    description: '座席设置转IVR',
    flow: 'Agent-->CCS',
  },
  137: {
    name: 'CONS_EU_AG_AgentSetTransferIVRAck_137',
    description: '座席设置转IVR ack',
    flow: 'CCS-->Agent',
  },
  138: {
    name: 'CONS_EU_AG_AgentChangeConfMode_138',
    description: '改变会议模式',
    flow: 'Agent-->CCS',
  },
  139: {
    name: 'CONS_EU_AG_AgentChangeConfModeAck_139',
    description: '改变会议模式 ack',
    flow: 'CCS-->Agent',
  },
  140: {
    name: 'CONS_EU_AG_ComComponentStatusEvt_140',
    description: '代理服务器通讯组件的状态',
    flow: 'Agent-->CCS',
  },
  141: {
    name: 'CONS_EU_AG_HEARTBEAT_141',
    description: '',
    flow: 'Agent-->CCS',
  },

  142: {
    name: 'CONS_EU_AG_AgentGetAllGroupReq_142',
    description: '取得所有的座席组的信息',
    flow: 'Agent-->CCS',
  },
  143: {
    name: 'CONS_EU_AG_AgentGetAllGroupAck_143',
    description: '取得所有的座席组的信息 ack',
    flow: 'CCS-->Agent',
  },
  144: {
    name: 'CONS_EU_AG_AgentRequestAgentStatus_144',
    description: '请求座席的状态',
    flow: 'Agent-->CCS',
  },
  145: {
    name: 'CONS_EU_AG_AgentRequestAgentStatusAck_145',
    description: '请求座席的状态 ack',
    flow: 'CCS-->Agent',
  },
  146: {
    name: 'CONS_EU_AG_AgentLoginEx_146',
    description: '座席登录扩展接口',
    flow: 'Agent-->CCS',
  },
  147: {
    name: 'CONS_EU_AG_AgentLoginExAck_147',
    description: '座席登录扩展接口 ack',
    flow: 'CCS-->Agent',
  },
  148: {
    name: 'CONS_EU_AG_END_FUNCTION_148',
    description: '座席登录扩展接口',
    flow: 'Agent-->CCS',
  }
}
export default {

  showAgentMessageName: function (msgfunc) {
    let data = agentMsgMap[msgfunc]
    if (data)
      return data.name
    else
      return msgfunc.toString()
  }
}